import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <title>{`${t('not_found.title')} - ${t('app_name')}`}</title>
      <div className="h-0 min-h-[768px] bg-background">
        <main className="grid min-h-full place-items-center bg-background px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <p className="text-base font-semibold text-selected">404</p>
            <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance text-foreground sm:text-7xl">
              {t('not_found.title')}
            </h1>
            <p className="mt-6 text-lg font-medium text-pretty text-muted-foreground sm:text-xl/8">
              {t('not_found.description')}
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Button asChild>
                <Link to="/">{t('not_found.go_back_home')}</Link>
              </Button>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
